import React from 'react';
import styles from './styles/LegalPages.module.css';
import SEO from '../../components/SEO/SEO';
import Layout from '../../components/Layout/Layout';

export default function TermsOfService() {
  // Mettre à jour le titre de la page
  React.useEffect(() => {
    document.title = 'Conditions d\'Utilisation - OV Hairstyle';
  }, []);

  return (
    <>
      <SEO
        title="Conditions d'Utilisation | OV Hairstyle"
        description="Consultez nos conditions d'utilisation pour connaître les règles d'accès à nos services."
        url="https://ovhairstyle.com/terms"
        image="https://ovhairstyle.com/images/og-image.jpg"
      />
      <Layout>
        <div className={styles.legalContainer}>
          <h1>CONDITIONS D'UTILISATION</h1>
          <p className={styles.lastUpdated}>Dernière mise à jour: 12 mars 2026</p>

          <h2>1. ACCEPTATION DES CONDITIONS</h2>
          <p>
            En utilisant les services de <strong>OV Hairstyle</strong>, y compris notre site web <strong>ov-hairstyle.com</strong> et notre plateforme <strong>WhatsApp Business</strong>,
            vous acceptez pleinement et sans réserve ces conditions d'utilisation.
          </p>
          <p>
            Si vous n'acceptez pas ces conditions, veuillez cesser d'utiliser nos services immédiatement.
          </p>

          <h2>2. SERVICES PROPOSÉS</h2>
          <p>OV Hairstyle propose les services suivants:</p>
          <ul>
            <li>Prestations de coiffure (coupes, couleurs, traitements)</li>
            <li>Prise de rendez-vous en ligne via WhatsApp</li>
            <li>Communication client via WhatsApp Business</li>
            <li>Devis et conseils en coiffure</li>
            <li>Consultations de style</li>
          </ul>

          <h2>3. COMMUNICATION VIA WHATSAPP BUSINESS</h2>
          <h3>3.1 Consentement et Acceptation</h3>
          <p>
            En fournissant votre numéro de téléphone WhatsApp, vous consentez explicitement à recevoir
            des messages de la part d'OV Hairstyle concernant:
          </p>
          <ul>
            <li>Confirmations de rendez-vous</li>
            <li>Rappels de rendez-vous (généralement 24h avant)</li>
            <li>Devis et propositions commerciales</li>
            <li>Réponses à vos questions</li>
            <li>Offres spéciales et promotions</li>
            <li>Mises à jour de nos services</li>
          </ul>

          <h3>3.2 Fréquence des Messages</h3>
          <p>
            Nous nous engageons à envoyer uniquement des messages pertinents et utiles.
            Nous ne spammerons pas votre numéro WhatsApp.
          </p>

          <h3>3.3 Désabonnement</h3>
          <p>
            Vous pouvez vous désabonner à tout moment en répondant <strong>"STOP"</strong> à l'un
            de nos messages. Nous cesserons alors de vous envoyer des messages commerciaux
            (sauf les confirmations de rendez-vous).
          </p>

          <h3>3.4 Tarification WhatsApp</h3>
          <p>
            Les messages WhatsApp peuvent être soumis aux tarifs de votre opérateur télécom. <strong>OV Hairstyle ne facture pas les messages WhatsApp.</strong> Les frais éventuels dépendent de votre forfait télécom.
          </p>

          <h2>4. RENDEZ-VOUS ET RÉSERVATIONS</h2>
          <h3>4.1 Prise de Rendez-vous</h3>
          <p>
            Les rendez-vous peuvent être pris:
          </p>
          <ul>
            <li>Via notre site web</li>
            <li>Via WhatsApp Business</li>
            <li>Par téléphone</li>
            <li>En personne au salon</li>
          </ul>

          <h3>4.2 Confirmation de Rendez-vous</h3>
          <p>
            <strong>Tous les rendez-vous doivent être confirmés 24 heures avant</strong> via WhatsApp ou téléphone. Un rendez-vous non confirmé peut être annulé.
          </p>

          <h3>4.3 Conditions d'Annulation</h3>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Délai d'annulation</th>
                <th>Frais</th>
                <th>Détails</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Plus de 24h avant</td>
                <td>Gratuit</td>
                <td>Annulation complètement gratuite</td>
              </tr>
              <tr>
                <td>Moins de 24h avant</td>
                <td>50% du tarif</td>
                <td>Frais d'annulation de dernière minute</td>
              </tr>
              <tr>
                <td>Pas de show (no-show)</td>
                <td>100% du tarif</td>
                <td>Perte complète du rendez-vous</td>
              </tr>
            </tbody>
          </table>

          <h3>4.4 Modification de Rendez-vous</h3>
          <p>
            Vous pouvez modifier votre rendez-vous (date/heure) gratuitement si vous le faites
            <strong> au moins 24 heures avant</strong> votre rendez-vous prévu.
          </p>

          <h3>4.5 Absence (No-Show)</h3>
          <p>
            Si vous ne vous présentez pas à votre rendez-vous sans annulation préalable,
            vous serez facturé du montant total du service prévu.
            Après deux no-shows, nous nous réservons le droit de refuser de futurs rendez-vous.
          </p>

          <h2>5. TARIFICATION ET PAIEMENT</h2>
          <h3>5.1 Tarifs</h3>
          <p>
            Tous nos tarifs sont affichés sur notre site web et communiqués lors de la prise de rendez-vous.
            Les tarifs peuvent varier selon le type de service et la durée.
          </p>

          <h3>5.2 Moyens de Paiement Acceptés</h3>
          <p>Nous acceptons les moyens de paiement suivants:</p>
          <ul>
            <li>Espèces</li>
            <li>Carte bancaire (Visa, Mastercard)</li>
            <li>Virement bancaire</li>
            <li>Mobile money (si disponible)</li>
          </ul>

          <h3>5.3 Paiement</h3>
          <p>
            <strong>Le paiement s'effectue à la réception du service</strong>,
            sauf accord préalable écrit.
          </p>

          <h3>5.4 Factures</h3>
          <p>
            Une facture vous sera remise après chaque service.
            Vous pouvez également la recevoir par email ou WhatsApp sur demande.
          </p>

          <h2>6. RESPONSABILITÉS</h2>
          <h3>6.1 Responsabilités d'OV Hairstyle</h3>
          <p>OV Hairstyle s'engage à:</p>
          <ul>
            <li>Fournir des services de coiffure de qualité</li>
            <li>Respecter vos données personnelles et les protéger</li>
            <li>Répondre à vos questions dans les 24 heures</li>
            <li>Respecter les horaires convenus</li>
            <li>Utiliser des produits de qualité</li>
            <li>Maintenir une hygiène et une propreté irréprochables</li>
          </ul>

          <h3>6.2 Responsabilités du Client</h3>
          <p>En tant que client, vous acceptez de:</p>
          <ul>
            <li>Fournir des informations exactes et complètes</li>
            <li>Respecter nos conditions d'utilisation</li>
            <li>Arriver à l'heure pour vos rendez-vous</li>
            <li>Informer le coiffeur de vos allergies ou sensibilités</li>
            <li>Respecter le personnel du salon</li>
            <li>Ne pas modifier ou annuler vos données sans autorisation</li>
          </ul>

          <h2>7. LIMITATION DE RESPONSABILITÉ</h2>
          <p>
            OV Hairstyle ne peut être tenu responsable de:
          </p>
          <ul>
            <li>Problèmes de connexion ou de fonctionnement de WhatsApp</li>
            <li>Retards ou non-réception de messages WhatsApp</li>
            <li>Interruptions de service dues à des tiers</li>
            <li>Dommages causés par l'utilisation de produits capillaires à domicile</li>
            <li>Réactions allergiques non signalées au préalable</li>
            <li>Dommages indirects ou consécutifs</li>
          </ul>

          <div className={styles.highlightBox}>
            <p>
              <strong>Important:</strong> Veuillez informer le coiffeur de toute allergie,
              sensibilité ou condition médicale avant le service.
            </p>
          </div>

          <h2>8. PROPRIÉTÉ INTELLECTUELLE</h2>
          <p>
            Tous les contenus du site web d'OV Hairstyle, y compris:
          </p>
          <ul>
            <li>Textes et descriptions</li>
            <li>Images et photos</li>
            <li>Logos et marques</li>
            <li>Vidéos et animations</li>
            <li>Designs et mises en page</li>
          </ul>
          <p>
            sont la propriété exclusive d'OV Hairstyle ou de ses partenaires.
            <strong> Toute reproduction, modification ou utilisation sans autorisation est interdite.</strong>
          </p>

          <h2>9. MODIFICATIONS DES CONDITIONS</h2>
          <p>
            OV Hairstyle se réserve le droit de modifier ces conditions d'utilisation à tout moment.
            Les modifications s'appliquent immédiatement après publication sur notre site.
          </p>
          <p>
            Pour les modifications importantes, nous vous notifierons par email ou via WhatsApp.
          </p>

          <h2>10. DROIT APPLICABLE</h2>
          <p>
            Ces conditions d'utilisation sont régies par la <strong>loi française</strong>.
            Tout litige sera soumis à la juridiction des tribunaux français.
          </p>

          <h2>11. DISPOSITIONS GÉNÉRALES</h2>
          <h3>11.1 Intégralité de l'Accord</h3>
          <p>
            Ces conditions constituent l'intégralité de l'accord entre vous et OV Hairstyle
            concernant l'utilisation de nos services.
          </p>

          <h3>11.2 Divisibilité</h3>
          <p>
            Si une partie de ces conditions est jugée invalide, les autres dispositions
            restent en vigueur.
          </p>

          <h3>11.3 Renonciation</h3>
          <p>
            Le fait que OV Hairstyle ne fasse pas valoir l'un de ses droits ne constitue pas
            une renonciation à ce droit.
          </p>

          <h2>12. CONTACT ET SUPPORT</h2>
          <p>
            Pour toute question concernant ces conditions ou nos services:
          </p>
          <div className={styles.contactBox}>
            <p><strong>OV Hairstyle</strong></p>
            <p><strong>Email:</strong> contact@ov-hairstyle.com</p>
            <p><strong>WhatsApp:</strong> +243  980 356 686</p>
            <p><strong>Téléphone:</strong> +243  980 356 686</p>
            <p><strong>Adresse:</strong> Kinshasa, RD Congo</p>
            <p><strong>Horaires:</strong> Lun-Sam 9h-18h</p>
          </div>

          <h2>13. RÉCLAMATIONS ET LITIGES</h2>
          <p>
            En cas de litige ou de réclamation, veuillez nous contacter dans les <strong>30 jours</strong> suivant l'incident. Nous ferons notre possible pour
            résoudre le problème rapidement et équitablement.
          </p>

          <h2>14. ACCEPTATION FINALE</h2>
          <p>
            En utilisant les services d'OV Hairstyle, vous confirmez que vous avez lu,
            compris et accepté ces conditions d'utilisation dans leur intégralité.
          </p>
        </div>
      </Layout>
    </>
  );
}
